// Crud Offline Online only. Shared table methods are in tableMixin.js.
import axios from "axios";
import { cachedGet } from "../../../../offline/offlineStore.js";

export default {
    name: "CrudOfflineOnline",
    methods: {
        openDatePicker() {
            this.$refs.dateInput.showPicker?.(); // supported in Chromium-based browsers
        },
        /* ---------------- Dynamic fields ---------------- */
        addField() {
            this.dynamicFields.fields.push({
                id: "new",
                fname: "",
                fage: "",
            });
        },
        handleFetchDynamicFieldsSuccess(response) {
            this.dynamicFields.fields = response.data.results.dfields;
        },
        fetchDynamicFields(postId) {
                // Offline: uses the rows saved the last time this record was opened online
                this.dynamicFieldsLoaded = false;
                cachedGet(`${this.apiUrl}?id=${postId}&action=getDynamicFields`, this.$handleConfig(), this.$offlineEnabled)
                    .then(({ response }) => {
                        if (response.data.status == "success") {
                            this.handleFetchDynamicFieldsSuccess(response);
                            this.dynamicFieldsLoaded = true;
                        } else {
                            this.handleError("ending", response.data.message, "danger", "modal");
                        }
                    })
                    .catch((error) => {
                        // Offline and never opened online: the rows are left out of the save, so they stay as they are
                        if (this.$offlineEnabled && !error.response) {
                            this.dynamicFields = this.getDefaultDynamicField();
                            this.handleAlert("ending", "You're offline, so this record's Dynamic Fields rows can't be shown. You can still change the other fields; the rows will stay as they are.", "warning", "modal");
                            return;
                        }
                        this.handleRequestError(error, "modal");
                    });
            },
            removeField(index, data_id) {
                this.$scrollToTopModal("recordFormModal");
                this.dynamicFields.fields.splice(index, 1); // Remove the field at the given index
                if (index == 0) {
                    // Add empty field there is no more to delete else proceed
                    this.addField();
                }
                if (data_id && data_id !== "new") {
                    this.deleteDynamicField(data_id);
                }
            },
            deleteDynamicField(dynamicFieldId) {
                this.handleAlert("starting", "Deleting...", "danger", "modal");

                const data = { id: dynamicFieldId, action: "deleteDynamicField" };
                axios
                    .delete(this.apiUrl, this.$handleConfig(data))
                    .then((response) => {
                        //alert(response.data);
                        if (response.data.status == "success") {
                            this.handleDeleteSuccess(response);
                        } else {
                            this.handleError("ending", response.data.message, "danger", "modal");
                        }
                    })
                    .catch((error) => {
                        this.handleRequestError(error, "modal");
                    });
            },
        /* ---------------- Sample button ---------------- */
        // Random sample person for the "Sample" button
        async addSampleData() {
               const person = this.samplePerson();

               // Clear old messages from a previous save
               this.defaultAlert = this.getDefaultAlert();

               // Access code: 6 random digits, put in both boxes
               const sampleCode = String(Math.floor(100000 + Math.random() * 900000));

               // Referred By: a random record from the table on screen (not one still waiting to sync: it has no real id yet)
               const rows = (this.tableData?.records || []).filter((r) => !r._pending);
               const referrer = rows.length ? rows[Math.floor(Math.random() * rows.length)] : null;

               this.formInputs = {
                  ...this.getDefaultFormInputs(),
                  firstname: person.firstname,
                  lastname: person.lastname,
                  name: person.firstname.slice(0, 3) + person.lastname.slice(0, 2), // nickname
                  email: person.email,
                  phonenumber: person.phone,
                  website: person.website,
                  sex: person.sex,
                  status: ["draft", "pending", "approved", "cancelled"][Math.floor(Math.random() * 4)],
                  checkbox1: true,     // "Check me" is required
                  radio1: person.sex,  // radio uses "male" / "female"
                  // A working-hours time, e.g. "2026-03-14 10:45"
                  date: `${person.date} ${String(8 + Math.floor(Math.random() * 10)).padStart(2, "0")}:${["00", "15", "30", "45"][Math.floor(Math.random() * 4)]}`,
                  amount: Number((Math.random() * 50000).toFixed(2)), // MoneyField
                  notes: `Sample record for ${person.firstname}.`,      // TextareaField
                  access_code: sampleCode,                              // PasswordField
                  access_code_confirm: sampleCode,                      // the same, so Confirm is valid
                  referred_by_id: referrer ? referrer.id : null,        // SearchSelectField
                  referred_by_name: referrer ? `${referrer.firstname} ${referrer.lastname}`.trim() : "",
               };

               // 1 to 4 dynamic rows, each a different person
               const rowCount = 1 + Math.floor(Math.random() * 4);
               this.dynamicFields = {
                  fields: Array.from({ length: rowCount }, () => {
                     const p = this.samplePerson();
                     return { id: "new", fname: p.fullName, fage: String(p.age) };
                  }),
               };

               // File is required for new records: attach an image with the initials
               const file = await this.sampleImage(person.firstname[0] + person.lastname[0]);
               if (file) {
                  this.formInputs.file = file;
                  if (this.$refs.fileInput) {
                     const dt = new DataTransfer();
                     dt.items.add(file);
                     this.$refs.fileInput.files = dt.files;
                  }
               }

               this.submitted = false;
               this.$clearValidationStates("#recordForm");
               this.$scrollToTopModal("recordFormModal");
            },
        samplePerson() {
            const pick = (list) => list[Math.floor(Math.random() * list.length)];
            const digits = (n) => Array.from({ length: n }, () => Math.floor(Math.random() * 10)).join("");

            const maleNames = ["John", "Brian", "Kevin", "Peter", "David", "James", "Samuel", "Daniel", "Joseph", "Collins"];
            const femaleNames = ["Mary", "Faith", "Grace", "Mercy", "Joy", "Esther", "Ann", "Lucy", "Sharon", "Cynthia"];
            const lastNames = ["Mwangi", "Ochieng", "Kipchoge", "Odhiambo", "Kariuki", "Mutiso", "Wekesa", "Korir", "Njoroge", "Omondi"];

            const sex = Math.random() < 0.5 ? "male" : "female";
            const firstname = pick(sex === "male" ? maleNames : femaleNames);
            const lastname = pick(lastNames);
            const suffix = digits(5); // keeps email/website unique

            // A local date (not UTC) within the last year, as YYYY-MM-DD
            const d = new Date(Date.now() - Math.floor(Math.random() * 365) * 86400000);
            const date = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

            return {
                firstname,
                lastname,
                fullName: `${firstname} ${lastname}`,
                sex,
                email: `${firstname}.${lastname}${suffix}@example.com`.toLowerCase(),
                phone: pick(["07", "01"]) + digits(8),
                website: `https://www.${firstname}${lastname}${suffix}.example.com`.toLowerCase(),
                age: 18 + Math.floor(Math.random() * 50),
                date,
            };
        },

        // A 200x200 PNG with some text (e.g. initials), returned as a File
        sampleImage(text = "S") {
            return new Promise((resolve) => {
                const canvas = document.createElement("canvas");
                canvas.width = 200;
                canvas.height = 200;
                const ctx = canvas.getContext("2d");

                ctx.fillStyle = `hsl(${Math.floor(Math.random() * 360)}, 60%, 45%)`;
                ctx.fillRect(0, 0, 200, 200);

                ctx.fillStyle = "#ffffff";
                ctx.font = "bold 80px Arial";
                ctx.textAlign = "center";
                ctx.textBaseline = "middle";
                ctx.fillText(String(text).toUpperCase(), 100, 105);

                canvas.toBlob((blob) => {
                    resolve(blob ? new File([blob], `sample_${Date.now()}.png`, { type: "image/png" }) : null);
                }, "image/png");
            });
        },
    },
};